[
  {
    "name": "accounts",
    "tag": "Accounts",
    "description": "A business on Whop: profile, wallet, capabilities, settings.",
    "group": "Core Resources"
  },
  {
    "name": "users",
    "tag": "Users",
    "description": "A person on Whop: profile and connected identities.",
    "group": "Core Resources"
  },
  {
    "name": "stats",
    "tag": "Stats",
    "description": "Aggregated account time series for reporting.",
    "group": "Core Resources"
  },
  {
    "name": "ledgers",
    "tag": "Ledgers",
    "description": "The activity feed behind an account or user's balance.",
    "group": "Money"
  },
  {
    "name": "payouts",
    "tag": "Payouts",
    "description": "Send money from a balance to a bank or wallet.",
    "group": "Money"
  },
  {
    "name": "cards",
    "tag": "Cards",
    "description": "Issue cards that spend from a balance.",
    "group": "Money"
  },
  {
    "name": "transfers",
    "tag": "Transfers",
    "description": "Move funds between Whop accounts and users.",
    "group": "Money"
  },
  {
    "name": "deposits",
    "tag": "Deposits",
    "description": "Add funds to a balance.",
    "group": "Money"
  },
  {
    "name": "swaps",
    "tag": "Swaps",
    "description": "Convert a balance between currencies.",
    "group": "Money"
  },
  {
    "name": "verifications",
    "tag": "Verifications",
    "description": "Identity review required before payouts and card issuing.",
    "group": "Money"
  },
  {
    "name": "products",
    "tag": "Products",
    "description": "The things you sell. Each owns plans and a store page.",
    "group": "Commerce"
  },
  {
    "name": "plans",
    "tag": "Plans",
    "description": "Pricing for a product: one-time, recurring, trials, stock.",
    "group": "Commerce"
  },
  {
    "name": "checkout-configurations",
    "tag": "Checkout Configurations",
    "description": "Turn a plan into a shareable, prefilled checkout link.",
    "group": "Commerce"
  },
  {
    "name": "partners",
    "tag": "Partners",
    "description": "The users and businesses you referred to Whop, and what you earn from them.",
    "group": "Referrals"
  },
  {
    "name": "workforce-bounties",
    "tag": "Workforce Bounties",
    "description": "Paid tasks with reviewed submissions and escrowed rewards.",
    "group": "Workforce"
  },
  {
    "name": "people",
    "tag": "People",
    "description": "Visitors and customers of an account, aggregated from pixel events.",
    "group": "Tracking"
  },
  {
    "name": "events",
    "tag": "Events",
    "description": "Conversion and engagement events tracked for attribution.",
    "group": "Tracking"
  },
  {
    "name": "ads",
    "tag": "Ads",
    "description": "The creative: copy, assets, and destination URL.",
    "group": "Ads"
  },
  {
    "name": "ad-campaigns",
    "tag": "Ad Campaigns",
    "description": "Platform, objective, and budget for a set of ads.",
    "group": "Ads"
  },
  {
    "name": "ad-groups",
    "tag": "Ad Groups",
    "description": "Audience, placements, and schedule within a campaign.",
    "group": "Ads"
  },
  {
    "name": "audiences",
    "tag": "Audiences",
    "description": "Reusable targeting lists for ad groups.",
    "group": "Ads"
  },
  {
    "name": "media",
    "tag": "Media",
    "description": "AI-generated assets, billed from a balance, attachable wherever files are accepted.",
    "group": "Media"
  },
  {
    "name": "social-accounts",
    "tag": "Social Accounts",
    "description": "Connected Facebook and Instagram accounts that run ads.",
    "group": "Identity"
  },
  {
    "name": "apps",
    "tag": "Apps",
    "description": "Apps you build on Whop: metadata, hosted builds, runtime logs.",
    "group": "Developer"
  }
]
